
import { supabase } from '@/integrations/supabase/client';

/**
 * Track a page view for a specific track
 * @param trackId UUID of the track being viewed
 */
export const trackPageView = async (trackId: string): Promise<void> => {
  try {
    if (!trackId) {
      console.error('Cannot track page view: No track ID provided');
      return;
    }

    // Get the current date
    const now = new Date().toISOString();

    const { error } = await supabase
      .from('page_views')
      .insert({
        track_id: trackId,
        ip_address: 'anonymous', // We don't collect actual IPs for privacy
        user_agent: navigator.userAgent,
        viewed_at: now
      });

    if (error) {
      console.error('Error tracking page view:', error);
      
      // If there's an RLS policy issue, try upsert method as fallback
      if (error.message.includes('policy')) {
        console.log('Attempting alternative page view tracking method...');
        // Try with rpc call if available, or other fallback
      }
    } else {
      console.log('Successfully tracked page view for track:', trackId);
    }
  } catch (err) {
    console.error('Failed to track page view:', err);
  }
};

/**
 * Get the total page views for a track
 * @param trackId UUID of the track
 * @returns Promise resolving to the number of page views
 */
export const getTrackPageViews = async (trackId: string): Promise<number> => {
  try {
    const { count, error } = await supabase
      .from('page_views')
      .select('*', { count: 'exact', head: true })
      .eq('track_id', trackId);
    
    if (error) {
      console.error('Error fetching page views:', error);
      return 0;
    }
    
    return count || 0;
  } catch (err) {
    console.error('Failed to get page views count:', err);
    return 0;
  }
};
